let descriptionBlocks = document.querySelectorAll(".description-prod");

descriptionBlocks.forEach((block) => {
  let container = document.createElement("div");
  container.innerHTML = block.innerHTML;

  let h6Tags = Array.from(container.querySelectorAll("h6"));

  if (h6Tags.length === 1) {
    // CASE 1: Only one <h6>
    let h6 = h6Tags[0];
    let contentAfter = "";
    let node = h6.nextSibling;

    while (node) {
      contentAfter += node.outerHTML || node.textContent;
      node = node.nextSibling;
    }

    let secTabMain = document.querySelector(".sec_tab__main");
    if (secTabMain) {
      let tabHeadingHolder = secTabMain.querySelector(".tab__hdngs .tab__hdng");
      let tabContentHolder = secTabMain.querySelector(".tab__cntnts .tab__cntnt .tab__cntnt__inner");

      if (tabHeadingHolder && tabContentHolder) {
        tabHeadingHolder.innerHTML = h6.innerText.trim();
        tabContentHolder.innerHTML = contentAfter;
      }
    }
  } else {
    // CASE 2: Multiple <h6> tags
    let descriptionHTML = "";
    let featuresHTML = "";
    let descriptionTitle = "";

    for (let i = 0; i < h6Tags.length; i++) {
      let currentH6 = h6Tags[i];
      let nextH6 = h6Tags[i + 1];
      let sectionTitle = currentH6.innerText.trim().toLowerCase();
      let formattedTitle = currentH6.innerText.trim().replace(/\b\w/g, (c) => c.toUpperCase());

      let contentBetween = "";
      let node = currentH6.nextSibling;

      while (node && node !== nextH6) {
        contentBetween += node.outerHTML || node.textContent;
        node = node.nextSibling;
      }

      if (sectionTitle.includes("description")) {
        descriptionTitle = formattedTitle;
        descriptionHTML = contentBetween;
      }

      if (sectionTitle.includes("features")) {
        let h4 = `<h4>${formattedTitle}</h4>`;
        featuresHTML = h4 + contentBetween;
      }

      if (sectionTitle.includes("specifications")) {
        let specificationContentHolder = document.querySelector(".meta_specification");
        if (specificationContentHolder) {
          specificationContentHolder.innerHTML = "";
          let h3 = document.createElement("h3");
          h3.classList.add("heading");
          h3.innerHTML = formattedTitle;
          specificationContentHolder.appendChild(h3);
          specificationContentHolder.insertAdjacentHTML("beforeend", contentBetween);
        }
      }
    }

    // Inject Description + Features together
    let secTabMain = document.querySelector(".sec_tab__main");
    if (secTabMain) {
      let tabHeadingHolder = secTabMain.querySelector(".tab__hdngs .tab__hdng");
      let tabContentHolder = secTabMain.querySelector(".tab__cntnts .tab__cntnt .tab__cntnt__inner");

      if (tabHeadingHolder && tabContentHolder) {
        tabHeadingHolder.innerHTML = descriptionTitle;
        tabContentHolder.innerHTML = descriptionHTML + featuresHTML;
      }
    }
  }
});
